import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import CustomerChatButton from '../components/CustomerChatButton';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = `${BACKEND_URL}/api`;

const CustomerBookAppointment = () => {
  const { user, token, getAuthHeaders, runningUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Use runningUser for role check (supports Run As mode)
  const effectiveUser = runningUser || user;

  useEffect(() => {
    if (effectiveUser?.role !== 'customer') {
      navigate('/dashboard');
      return;
    }
    fetchCustomerCalendar();
  }, [effectiveUser]);

  const fetchCustomerCalendar = async () => {
    try {
      setLoading(true);
      
      // Get customer's calendar details - use getAuthHeaders for Run As support
      const response = await axios.get(
        `${API_BASE_URL}/calendar-registrations/my-calendar/details`,
        { headers: getAuthHeaders() }
      );

      const calendar = response.data.data?.calendar;
      
      if (calendar && calendar.symbolic_name) {
        // Redirect to calendar view using symbolic name
        navigate(`/calendar/${calendar.symbolic_name}`);
      } else {
        setError('Calendar not found. Please contact the calendar administrator.');
      }
    } catch (err) {
      console.error('Error fetching calendar:', err);
      const errorMsg = err.response?.data?.detail || 'Failed to load your calendar. Please try again.';
      
      if (errorMsg.includes('not registered')) {
        setError('You are not registered to any calendar. Please find a calendar from the home page.');
      } else {
        setError(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="flex flex-col items-center justify-center py-20">
        {loading ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mb-4"></div>
            <p className="text-gray-600">Loading your calendar...</p>
          </>
        ) : error ? (
          <div className="max-w-md text-center">
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
            <button
              onClick={() => navigate('/find-calendar')}
              className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-md transition-colors"
            >
              Find a Calendar
            </button>
          </div>
        ) : null}
      </div>
      
      {/* Floating Chat Button for Customers */}
      <CustomerChatButton />
    </div>
  );
};

export default CustomerBookAppointment;
